import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorArticleNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IArticleModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IArticleFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useArticleHookNae(id: number) : IArticleModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorArticleNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "article",
        fields: IArticleFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
